<template>
    <span>
        <b-card :no-body="true" border-variant="primary" v-if="selecionado">
            <b-card-body class="m-2">
                <!-- <i
                    :class="`fa ${icone} bg-${corBox} p-4 font-2xl mr-3 float-left`"
                ></i> -->
                <div :class="`h3 text-${corTexto}`">
                    <slot></slot>
                </div>
                <div
                    class="text-muted text-uppercase font-weight-bold descricao"
                >
                    {{ titulo }}
                </div>
            </b-card-body>
        </b-card>
        <b-card :no-body="true" v-if="!selecionado">
            <b-card-body class="p-0 clearfix m-2">
                <!-- <i
                    :class="`fa ${icone} bg-${corBox} p-4 font-2xl mr-3 float-left`"
                ></i> -->
                <div :class="`h3 text-${corTexto}`">
                    <slot></slot>
                </div>
                <div
                    class="text-muted text-uppercase font-weight-bold descricao"
                >
                    {{ titulo }}
                </div>
            </b-card-body>
        </b-card>
    </span>
</template>

<script>
export default {
    props: {
        icone: {
            type: String,
            default: () => 'fa-dollar'
        },

        titulo: {
            type: String,
            default: () => ''
        },

        corBox: {
            type: String,
            default: () => 'primary'
        },

        corTexto: {
            type: String,
            default: () => 'primary'
        },

        selecionado: {
            type: Boolean,
            default: () => false
        }
    }
}
</script>

<style scoped>
.descricao {
    font-size: 0.8em;
}
</style>